import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { BUSINESS } from "@/data/site";
import { trackEvent } from "@/lib/api";

export default function MobileStickyCTA() {
  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 px-3 pt-3 pb-[calc(env(safe-area-inset-bottom,0px)+12px)] bg-gradient-to-t from-parchment via-parchment/95 to-transparent"
      data-testid="mobile-sticky-cta"
    >
      <div className="flex gap-2.5 max-w-md mx-auto">
        <a
          href={BUSINESS.phoneHref}
          onClick={() => trackEvent("call_click", { source: "sticky_cta" })}
          className="flex-1 inline-flex items-center justify-center gap-2 bg-white border-2 border-[#E2D7C3] text-espresso py-3.5 rounded-full font-bold text-sm shadow-soft active:scale-[0.98] transition-transform"
          data-testid="sticky-call-btn"
        >
          <Phone className="w-4 h-4 text-gold" /> Call
        </a>
        <Link
          to="/book"
          onClick={() => trackEvent("cta_click", { source: "sticky_cta" })}
          className="flex-[1.7] inline-flex items-center justify-center gap-2 bg-coral text-white py-3.5 rounded-full font-bold text-sm shadow-pop active:scale-[0.98] transition-transform"
          data-testid="sticky-request-btn"
        >
          Request a Sitter
        </Link>
      </div>
    </div>
  );
}
